<template>
    <Card :title="$t('labels.project')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.project_name')">
                        <Input v-model="name" type="text"/>
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.project_alias')">
                        <Input :model-value="project?.alias" type="text" readonly/>
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <Button size="sm" color="teal" @click="save">
                {{ $t('buttons.save') }}
            </Button>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../../components/new/CardComponent.vue';
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../../components/new/form/Input.vue';
import Button from '../../../../../components/new/button/AppButton.vue';

import { httpClient } from '../../../../../services/HttpClient';
import MessageNotificator from '../../../../../services/MessageNotificator';
import { mapGetters } from 'vuex';

export default {
    name: "ProjectCard",
    components: {
        Card, FormGroup, Input, Button
    },
    data() {
        return {
            name: ''
        }
    },
    computed: {
        ...mapGetters('route', ['project'])
    },
    methods: {
        async save() {
            await httpClient.patch(`/projects/${this.$route.params.projectUuid}`, {
                name: this.name
            });

            await this.$store.dispatch('route/fetchProject', this.$route.params.projectUuid);

            new MessageNotificator().success(this.$t('alerts.success'));
        }
    },
    watch: {
        project: {
            handler(project) {
                this.name = project?.name ?? '';
            },
            immediate: true
        }
    }
}
</script>
